<h6>{{ 'tytul.wyslij-wiadomosc' | translate }}</h6>
<form [formGroup]="form" (ngSubmit)="onSubmit(form.value, form.valid)">

  <div class="form-group">
    <label for="celInput" class="label">{{ 'etykieta.skontaktuj' | translate }}</label>
    <nb-select formControlName="cel" fullWidth id="celInput" placeholder="{{ 'etykieta.wybierz' | translate }}">
      <nb-option *ngIf="token.klientId" value="KSIEGOWY">{{ 'info.kontakt.wiadomosc.twoj-ksiegowy' | translate }}</nb-option>
      <nb-option *ngIf="token.klientId" value="KADRY_PLACE">{{ 'info.kontakt.wiadomosc.specjalista-kadry-place' | translate }}</nb-option>
      <nb-option value="DORADCA_SPRZEDAZY">{{ 'info.kontakt.wiadomosc.doradca-sprzedazy' | translate }}</nb-option>
      <nb-option *ngIf="token.klientId" value="KOORDYNATOR_KSIEGOWY">{{ 'info.kontakt.wiadomosc.koordynator-ksiegowy' | translate }}</nb-option>
    </nb-select>
    <ng-container *ngIf="f.cel.errors && f.cel.touched">
      <p class="caption status-danger" *ngIf="f.cel.errors.required">{{ 'komunikat.blad.pole-wymagane' | translate }}!</p>
    </ng-container>
  </div>

  <div class="form-group">
    <label for="tematInput" class="label">{{ 'etykieta.temat' | translate }}</label>
    <input nbInput formControlName="temat" fullWidth id="tematInput" placeholder="{{ 'etykieta.temat' | translate }}">
    <ng-container *ngIf="f.temat.errors && f.temat.touched">
      <p class="caption status-danger" *ngIf="f.temat.errors.required">{{ 'komunikat.blad.pole-wymagane' | translate }}!</p>
    </ng-container>
  </div>

  <div class="form-group">
    <label for="trescInput" class="label">{{ 'etykieta.tresc' | translate }}</label>
    <textarea nbInput formControlName="tresc" fullWidth id="trescInput" placeholder="{{ 'etykieta.tresc' | translate }}"></textarea>
    <ng-container *ngIf="f.tresc.errors && f.tresc.touched">
      <p class="caption status-danger" *ngIf="f.tresc.errors.required">{{ 'komunikat.blad.pole-wymagane' | translate }}!</p>
    </ng-container>
  </div>

  <button nbButton type="submit" status="danger">{{ 'akcja.wyslij' | translate }}</button>
</form>
